import * as SubsidiesSelector from './components/SubsidiesSelector/SubsidiesSelector.css';
import * as SubsidiesSelectorRadio from './components/SubsidiesSelector/SubsidiesSelectorRadio.css';
import * as SubsidiesResult from './components/SubsidiesResult/SubsidiesResult.css';
import * as SubsidiesPassenger from './components/SubsidiesResultPassenger/SubsidiesResultPassenger.css';

export default {
	SubsidiesSelector,
	SubsidiesResult,
	SubsidiesPassenger,
	SubsidiesSelectorRadio
};
